import { styled, Paper } from "@mui/material"

const CutomPaper = styled(Paper)(() => ({
    padding: "1.5rem",
    borderRadius: "2px"
}))

export default CutomPaper